/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*
*/

import { HttpParams } from "@angular/common/http";
import { SraChart } from "@src/app/modules/agent/agent-dashboard-page/SraChart";

export class SraMyOmcChart extends SraChart {
    title = "My OMC Requests Status";
    dataParams = new HttpParams().set('week', 0).set('show', 'myomcs');
}
